import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Grid, FormControlLabel, Checkbox } from '@material-ui/core';

import { useValidateAction } from 'Utils/actions';
import { actions } from 'Constants/actions';

function PaymentOptions({ paymentOptions, setPaymentOptions, className }) {
  const { values, setFieldValue } = useFormikContext();
  const allowCardReaderPayments = values?.event?.venue?.allowCardReaderPayments || false;

  useEffect(() => {
    if (paymentOptions) {
      setFieldValue('deferredGroupId', null);
      setFieldValue('ccInformation.useCard', !!(paymentOptions && paymentOptions.card));
      setFieldValue('ccInformation.groupBill', false);
      setFieldValue('ccInformation.cardReaderPayment', !!(paymentOptions && paymentOptions.cardReader));
    }
  }, [paymentOptions]);

  const handleUseCash = () => {
    setPaymentOptions(prevState => {
      if (prevState && prevState.cash && (prevState.card || prevState.cardReader)) {
        return { ...paymentOptions, cash: false };
      }

      return { ...paymentOptions, cash: true, cardReader: false };
    });
  };

  const handleUseCard = () => {
    setPaymentOptions(prevState => {
      if (prevState && prevState.card && (prevState.cash || prevState.cardReader)) {
        return { ...paymentOptions, card: false };
      }

      return { ...paymentOptions, card: true, cardReader: false };
    });
  };

  const handleUseCardReader = () => {
    setPaymentOptions(prevState => {
      if (prevState && prevState.cardReader && (prevState.card || prevState.cash)) {
        return { ...paymentOptions, cardReader: false };
      }

      return { ...paymentOptions, cardReader: true, cash: false, card: false };
    });
  };

  const canSelectCashPayment = useValidateAction('orders', actions.DEFERRED_SETLEMENT_CASH_PAYMENT);

  return (
    <>
      <Grid item xs>
        <FormControlLabel
          id="credit-debit-control"
          value="creditOrDebitCard"
          control={<Checkbox color="primary" id={`check-credit-debit`} />}
          checked={paymentOptions && paymentOptions.card === true}
          onChange={handleUseCard}
          className={`${className}__payment-option`}
          label={`Credit/Debit Card`}
        />
      </Grid>
      {canSelectCashPayment && (
        <Grid item xs>
          <FormControlLabel
            id="cash-control"
            value="cash"
            control={<Checkbox color="primary" id={`check-cash`} />}
            checked={paymentOptions && paymentOptions.cash === true}
            onChange={handleUseCash}
            className={`${className}__payment-option`}
            label={`Cash or Check`}
          />
        </Grid>
      )}
      {allowCardReaderPayments && (
        <Grid item xs>
          <FormControlLabel
            id="card-reader-control"
            value="cardReaderPayment"
            control={<Checkbox color="primary" id={`card-reader`} />}
            checked={paymentOptions && paymentOptions.cardReader === true}
            onChange={handleUseCardReader}
            className={`${className}__payment-option`}
            label={`POS`}
          />
        </Grid>
      )}
    </>
  );
}

export default PaymentOptions;
